var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-view"},[_c('div',{staticClass:"p-4"},[_vm._t("default")],2),_c('div',{staticClass:"p-4 text-right"},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }